<template>
  <component :is="process" :vacancyId="vacancyId" />
</template>

<script>
import basic from '@/routes_new/inner/vacancy/video/base/default.vue';
import bat from '@/process/bat-personal-account/components/vacancy/preferences/SpecialProcess.vue';
import deloitte from '@/process/deloitte-sf/components/vacancy/preferences/SpecialProcess.vue';
import citibank from '@/process/citibank/components/vacancy/preferences/SpecialProcess.vue';
import unilever from './SpecialProcess.vue';

export default {
  name: 'basic',
  components: {
    default: basic,
    schlum: basic,
    bat,
    deloitte,
    citibank,
    unilever
  },
  props: {
    process: {
      type: String,
      required: true
    },
    vacancyId: {
      type: String,
      required: true
    }
  },
  created() {
    switch(this.process) {
      case 'deloitte': {
        this.$store.dispatch('process/deloitteSF/vacancy/SFVacanciesList/fetch');
        break;
      }
      case 'citibank': {
        this.$store.dispatch('process/citibank/vacancy/additionalData/fetch', this.$store.getters['vacancy_new/item']);
        break;
      }
    }
  }
}
</script>